export const serviceCopy = {
  resultTime:
    'Get your written Listen Result in your JG account within 72 hours of your complete submission.',
  clockRule:
    'That means 72 calendar hours, including weekends, from receipt of the required information and a playable song link—not from when Joe opens it. If something prevents review, we’ll contact you promptly with what’s needed.',
  plusRefund:
    'If your song isn’t eligible for Plus advertising, we’ll refund $40. Your $9.99 Basic review is still included, and you keep Joe Galaxy’s Listen Result.',
  activation:
    'Eligible advertising starts within seven calendar days after we receive all required usable materials. If we can’t meet that deadline, we’ll refund the $40 Plus portion. Your six-month advertising term starts at activation.',
  refundTiming:
    'We initiate qualifying $40 refunds within two business days. Your $9.99 Basic review stays included. Your bank may take additional time to post the refund.',
  materials:
    'If a link or advertising material is unusable, we’ll tell you what’s needed and set a resolution date. Advertising eligibility is separate from earned JG Radio rotation.',
};
export const EXAMPLE_TRACK_ID = 'uneekint-i-got-faith-edm-remix';
export const OFFER_VERSION = 'paid-offer-v3-sharing';
